// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3zbOn","tabsBox":"styles_tabsBox__25e6b","createButton":"styles_createButton__3tkrj"};